import Vue from 'vue'
export default {
    // 对象的克隆
    cloneObj(obj) {
        var o;
        switch (typeof obj) {
            case 'undefined': break;
            case 'string': o = obj + ''; break;
            case 'number': o = obj - 0; break;
            case 'boolean': o = obj; break;
            case 'object':
                if (obj === null) {
                    o = null;
                } else {
                    if (obj instanceof Array) {
                        o = [];
                        for (var i = 0, len = obj.length; i < len; i++) {
                            o.push(this.cloneObj(obj[i]));
                        }
                    } else {
                        o = {};
                        for (var k in obj) {
                            o[k] = this.cloneObj(obj[k]);
                        }
                    }
                }
                break;
            default:
                o = obj;
                break;
        }
        return o;
    },
    // 转换时间日期格式
    addTime(m) {
        return m < 10 ? '0' + m : m
    },
    // timeType
    // 1: yy-mm-dd hh:mm:ss
    // 2: yy-mm-dd hh:mm
    // 3: yy-mm-dd
    // 4: hh:mm
    format(timeTemp, timeType) {
        let _self = this;
        let time = new Date(timeTemp);
        let type = timeType;
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        if (type === 1) {
            let date = y + '-' + _self.addTime(m) + '-' + _self.addTime(d) + ' ' + _self.addTime(h) + ':' + _self.addTime(mm) + ':' + _self.addTime(s);
            return date
        } else if (type === 2) {
            let date = y + '-' + _self.addTime(m) + '-' + _self.addTime(d) + ' ' + _self.addTime(h) + ':' + _self.addTime(mm);
            return date
        } else if (type === 3) {
            let date = y + '-' + _self.addTime(m) + '-' + _self.addTime(d);
            return date
        } else if (type === 4) {
            let date = _self.addTime(h) + ':' + _self.addTime(mm);
            return date
        } else {
            let date = y + '-' + _self.addTime(m) + '-' + _self.addTime(d) + ' ' + _self.addTime(h) + ':' + _self.addTime(mm) + ':' + _self.addTime(s);
            return date
        }
    },
    isBlank(value) {
        return value === null || value === undefined || value === 'null' || value === 'undefined' || value === '';
    },
    // 加密手机号码
    encryptionPhone(cellValue) {
        console.log('cellValue', cellValue)
        if (Number(cellValue) && String(cellValue).length === 11) {
            var mobile = String(cellValue)
            var reg = /^(\d{3})\d{4}(\d{4})$/
            return mobile.replace(reg, '$1****$2')
        } else {
            return cellValue
        }
    },
    // ios手机
    appType() {
        let ua = navigator.userAgent.toLowerCase();
		//android终端
		let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; //ios终端
		let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		if (isWeixinBrowser()) {
			this.ShowDark = !this.ShowDark;
			return 'WEIXIN';
		} else {
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				//ios
				return 'IOS';

			} else if (/(Android)/i.test(navigator.userAgent)) {
				//android
				return 'Android';
			}
		}

		function isWeixinBrowser() {
			return (/micromessenger/.test(ua)) ? true : false;
		}
    },
    // 切换手机横屏竖屏  "0" 横屏  "1"竖屏    
    setScreenDirection(type) {
        var u = navigator.userAgent;
        console.log(type)
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isIOS) {
            try {
                window.webkit.messageHandlers.setScreenDirection.postMessage(type);
            } catch (error) {
                console.log(error)
               // window.alert(error)
            }
        } else {
            try {
                window.appSdk.setScreenDirection(type);
            } catch (error) {
                console.log(error)
               // window.alert(error)
            }
        }
    },
    // 跳转外部链接
    openUrl(url) {
        console.log('url',url)
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isIOS) {
            try {
                //window.alert('进入调用方法',url)
                window.webkit.messageHandlers.openUrl.postMessage(url);
            } catch (error) {
                console.log(error)
                window.alert(error)
            }
        } else {
            try {
                window.appSdk.openUrl(url);
            } catch (error) {
                console.log(error)
                window.alert(error)
            }
        }  
    },
    // 更新版本号
    updatedVersion(num) {
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isIOS) {
            try {
                window.webkit.messageHandlers.h5Upgrade.postMessage(num);
            } catch (error) {
                console.log(error)
                //window.alert(error)
            }
        } else {
            try {
                window.appSdk.h5Upgrade(num);
            } catch (error) {
                console.log(error)
               // window.alert(error)
            }
        }  
    }
}


// WEBPACK FOOTER //
// ./src/utils/util.js